import StorageDisclosureTable from './StorageDisclosureTable'

export default StorageDisclosureTable
